/**
 * 前端多语言解决方案
 */
import _ from 'underscore';
import url from 'c-url';
import native from 'c-up-native';
import LangPack from './pack';

let lang = url.query('lang');
let tws = ['zh-SG', 'zh-MO', 'zh-TW', 'zh-HK'];
let ars = [
    'ar-AE',
    'ar-BH',
    'ar-DZ',
    'ar-EG',
    'ar-IQ',
    'ar-JO',
    'ar-KW',
    'ar-LB',
    'ar-LY',
    'ar-MA',
    'ar-OM',
    'ar-QA',
    'ar-SA',
    'ar-SY',
    'ar-TN',
    'ar-YE'
];
if (native.getPlatform() !== 'uplive' && !localStorage.getItem('isUplive')) {
    if (!lang) {
        let systemLanguage = navigator.language || navigator.browserLanguage;
        let _systemLanguage = systemLanguage.toLowerCase();

        switch (_systemLanguage) {
            case 'ar':
                systemLanguage = 'ar-EG';
                break;
            case 'vi':
                systemLanguage = 'vi-VN';
                break;
            case 'en':
                systemLanguage = 'en-US';
                break;
            case 'ja':
                systemLanguage = 'ja-JP';
                break;
            case 'zh':
                systemLanguage = 'zh-CN';
                break;
            default:
                break;
        }

        let arr = systemLanguage.split('-');

        if (arr.length > 1) {
            systemLanguage = arr[0] + '-' + arr[1].toUpperCase();
        } else {
            systemLanguage = 'en-US';
        }

        if (systemLanguage == 'zh-CN' || systemLanguage == 'ja-JP' || systemLanguage == 'vi-VN') {
            lang = systemLanguage;
        } else if (tws.indexOf(systemLanguage) >= 0) {
            lang = 'zh-TW';
        } else if (ars.indexOf(systemLanguage) >= 0) {
            lang = 'ar-EG';
        } else {
            lang = 'en-US';
        }
    }
} else {
    lang = lang || 'en-US';
}

let langType = lang.replace('-', '').toLowerCase();
let langPack = LangPack[langType] || LangPack['enus'];

let _lang = {

    type: lang,

    init: function() {
        $('html').attr('lang', lang);
        $('body').addClass(langType);
    },

    template: function(tplStr, data, insertEM){
        let tpl = langPack[tplStr] || tplStr;
        if (tpl) {
            if (tpl.indexOf('@@@@') > 0) {
                let strArr = [];

                strArr.push('<ul>');
                tpl.split('@@@@').forEach(function(item, index){
                    item && strArr.push('<li>' + item + '</li>');
                });
                strArr.push('</ul>');
                tpl = strArr.join('');
            }
            if (insertEM) {
                tpl = tpl.replace(/<%=([\s\S]+?)%>/g, function($0, $1){
                    return '<em class="' + $1 +'">' + $0+ '</em>';
                });
            }

            let compiled = _.template(tpl);
            return compiled(data);

        } else {
            return _.template(tplStr)(data);
        }
    }
};

_lang.init();
window._lang = _lang;
module.exports = _lang;



// WEBPACK FOOTER //
// ./js/lang/index.js